var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saveButton"},[_c('button',{staticClass:"btn userButton btn-secondary saveButton-Button",attrs:{"type":"button"},on:{"click":function($event){return _vm.save()}}},[_vm._v(_vm._s(_vm.label))]),_c('div',{class:'saveButton-Status ' + _vm.msgDirection},[_c('span',[_vm._v(_vm._s(_vm.state))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }